import React from 'react';
import { useSelector } from 'react-redux';
import useFetch from 'use-http';
import { IRootState } from 'src/reducers';
import { Url } from 'src/api';
import { Form } from 'react-final-form';
import FormTextBox, { FormTextBoxDataType } from 'src/components/controls/forms/redesign/FormTextbox';
import IOwner from 'src/models/IOwner';
import OwnerDisplay from './OwnerDisplay';
import FormSelect from 'src/components/controls/forms/redesign/FormFilterSelect';
import { SelectItem } from 'src/models/common/SelectItem';

interface IAddEasternOwnershipProps {
    ownerId: number;
    updateInterest: (interest: string) => void;
    updateAdditionalTypeId?: (id: number) => void;
    parentOwnershipId?: number;
    error?: string;
}

const AddEasternOwnership: React.FC<IAddEasternOwnershipProps> = (props) => {
    const appContext = useSelector((state: IRootState) => state.appContext);
    const { get, response } = useFetch();
    const [owner, setOwner] = React.useState<IOwner>(undefined);

    // tslint:disable-next-line: no-empty
    const noop: () => void = () => {};

    const updateDecimalInterest = (event: React.FocusEvent<HTMLInputElement>) => {
        props.updateInterest(event.currentTarget.value);
    };

    const updateAdditionalTypeId = (id: number) => {
        props.updateAdditionalTypeId(id);
    };

    React.useEffect(() => {
        loadOwner(props.ownerId);
    }, [props.ownerId]);

    const loadOwner = async (ownerId: number) => {
        const result = await get(`${Url.project.getProject(appContext, appContext.projectNumber)}/owners/${ownerId}`);

        if (response.ok) {
            setOwner(result);
        }
    };

    return (
        <>
            <OwnerDisplay owner={owner} displayStyle="Flat" />
            <hr style={{ marginBottom: '1.5rem' }} />
            {props.error && <div>{props.error}</div>}
            <Form
                onSubmit={noop}
                render={({ handleSubmit }) => {
                    return (
                        <form onSubmit={handleSubmit}>
                            <div>
                                <FormTextBox
                                    type={FormTextBoxDataType.Float}
                                    label="Decimal Interest"
                                    name="decimalInterest"
                                    onBlur={updateDecimalInterest}
                                    className="lh-half-width"
                                    isRequired={true}
                                />
                                {props.parentOwnershipId > 0 && (
                                    <FormSelect
                                        name="additionalOwnershipTypeId"
                                        label="Additional Ownership Type"
                                        onChange={(id: number) => updateAdditionalTypeId(id)}
                                        items={[
                                            new SelectItem(1, 'HEIR'),
                                            new SelectItem(2, 'REMAINDERMAN'),
                                            new SelectItem(3, 'NON-EXECUTIVE'),
                                            new SelectItem(4, 'NON-PARTICIPATING'),
                                            new SelectItem(5, 'TRANSFER ON DEATH'),
                                            new SelectItem(6, 'NAKED OWNER'),
                                        ]}
                                        className="lh-half-width"
                                        isRequired={true}
                                    />
                                )}
                            </div>
                        </form>
                    );
                }}
            />
        </>
    );
};

export default AddEasternOwnership;



// WEBPACK FOOTER //
// ./src/components/project/sections/tract/components/AddEasternOwnership.tsx